import { PaymentDeviceDao } from "@/data/dao/service/PaymentDeviceDao";
import { VoucherDao } from "@/data/dao/service/VoucherDao";
import { AuthTokenService } from "@/data/services/AuthTokenService";
import { UserSessionService } from "@/data/services/UserSessionService";

import { CookieCache } from "./offline/CookieCache";
import { FallbackCookieCache } from "./offline/FallbackCookieCache";
import { HTML5LocalCache } from "./offline/Html5LocalCache";
import { AuditDao } from "./service/AuditDao";
import { AuthenticationDao } from "./service/AuthenticationDao";
import { BookingDao } from "./service/BookingDao";
import { CatalogDao } from "./service/CatalogDao";
import { CustomerDao } from "./service/CustomerDao";
import { DashboardDao } from "./service/DashboardDao";
import { DiscountsDao } from "./service/DiscountsDao";
import { DocumentDao } from "./service/DocumentDao";
import { FeedbackDao } from "./service/FeedbackDao";
import { KioskDao } from "./service/KioskDao";
import { LocationDao } from "./service/LocationDao";
import { LogDao } from "./service/LogDao";
import { LogsDao } from "./service/LogsDao";
import { NotificationDao } from "./service/NotificationDao";
import { OperatorDao } from "./service/OperatorDao";
import { OrderDao } from "./service/OrderDao";
import { PlanningDao } from "./service/PlanningDao";
import { PrintDao } from "./service/PrintDao";
import { ProfileDao } from "./service/ProfileDao";
import { QrCodeDao } from "./service/QrCodeDao";
import { RoomDao } from "./service/RoomDao";
import { SubscriptionDao } from "./service/SubscriptionDao";
import { SupportDao } from "./service/SupportDao";
import { SystemDao } from "./service/SystemDao";
import { TableDao } from "./service/TableDao";
import { UserDao } from "./service/UserDao";
import { BillDao } from "@/data/dao/service/BillDao";

export const daoServicesList = {
    AuditDao: AuditDao,
    AuthenticationDao: AuthenticationDao,
    BillDao: BillDao,
    BookingDao: BookingDao,
    CatalogDao: CatalogDao,
    CustomerDao: CustomerDao,
    DashboardDao: DashboardDao,
    DiscountsDao: DiscountsDao,
    DocumentDao: DocumentDao,
    FeedbackDao: FeedbackDao,
    KioskDao: KioskDao,
    LocationDao: LocationDao,
    LogDao: LogDao,
    NotificationDao: NotificationDao,
    OperatorDao: OperatorDao,
    OrderDao: OrderDao,
    PlanningDao: PlanningDao,
    PrintDao: PrintDao,
    ProfileDao: ProfileDao,
    QrCodeDao: QrCodeDao,
    RoomDao: RoomDao,
    SubscriptionDao: SubscriptionDao,
    SupportDao: SupportDao,
    SystemDao: SystemDao,
    TableDao: TableDao,
    UserDao: UserDao,
    CookieCache: CookieCache,
    HTML5LocalCache: HTML5LocalCache,
    FallbackCookieCache: FallbackCookieCache,
    LogsDao: LogsDao,
    AuthTokenService: AuthTokenService,
    UserSessionService: UserSessionService,
    VoucherDao: VoucherDao,
    PaymentDeviceDao: PaymentDeviceDao,
};
